import { AuthService } from './auth.service';
import { CommonService } from './common.service';
import { ClientWalkInService } from './clientWalkIn.service';
import { FollowUpService } from './followUp.service';
import { SubscribeService } from './subscribe.service';
import { BranchService } from './branch.service';
import { EmployeeService } from './employee.service';
import { ClientService } from './client.service';
import { ReferenceService } from './reference.service';
import { PocService } from './poc.service';
import { HearingLossService } from './hearingLoss.service';
import { BrandService } from './brand.service';
import { BrandmodelService } from './brandmodel.service';
import { HamodelService } from './hamodel.service';
import { TestingBillService } from './testingBill.service';
import { ChallanOutService } from './challanOut.service';
import { ChallanInService } from './challanIn.service';
import { TransferChallanOutService } from './tcOut.service';
import { TransferChallanInService } from './tcIn.service';
import { SalesBillentryService } from './salesBillentry.service';
import { clientOutService } from './clientOut.service';
import { ReportsService } from './reports.service';
import { TestingTrailService } from './testingTrail.service';
import { PurchasePartyService } from './purchaseParty.service';
import { ServiceWalkInService } from './serviceWalkIn.service';
import { FamilyService } from './family.service';
import { UserService } from './user.service';
import { ServiceEntryService } from './serviceEntry.service';
import { SalesReturnService } from './salesReturn.service';
import { AdvanceReturnService } from './advanceReturn.service';
import { CashPaymentService } from './cashPayment.service';
import { CashReceiptService } from './cashReceipt.service';
import { PhClientService } from './phClient.service';
import { PurchaseInvoiceService } from './purchaseInvoice.service';
import { ServiceInvoiceService } from './serviceInvoice.service';
import { PurchaseReturnService } from './purchaseReturn.service';
import { NewPurchaseReturnService } from './newPurchaseReturn.service';
import { EditService } from './edit.service';
import { FollowUpClientUploadService } from './followUpClientUpload.service';
import { CacService } from './cac.service';
import { ProTaskRemainderService } from './proTaskRemainder.service';
import { SmsService } from './sms.service';
import { BackupFollowUpClientService } from './backupFollowUpClient.service';
// import { VoucherDateChangeService } from './voucherdatechanges.service';
import { AppointmentService } from './appointment.service';
import { CashOutService } from './cashOut.service';
import { CashInService } from './cashIn.service';
import { ExpenseService } from './expense.service';
import { SeriesService } from './series.service';
import { PowerService } from './power.service';
import { PerformanceService } from './performance.service';
import { DesignService } from './design.service';
import { BatteryService } from './battery.service';
import { AiStatusService } from './aiStatus.service';
import { AiCallConfigService } from './aiCallConfig.service';
import { AiFollowupConfigService } from './aiFollowupConfig.service';
import { AiTrackDayService } from './aiTrackDay.service';
import { AiSettingsService } from './aiSettings.service';
import { HsnService } from './hsn.service';
import { from } from 'rxjs/observable/from';
import { DashboardService } from './dashboard.service';
import { PartyNameService } from './partyName.service';
import { CouponPointsService } from './couponPoints.service';
import { DoctorService } from './doctor.service';
import { LedgerMasterService } from './ledgerMaster.service';
import { ExpenseTypeService } from './expenseType.service';
import { OctTypeService } from './octType.service';
import { DoctorIncentiveService } from './doctorIncentive.service';
import { DoctorIncentiveTestingService } from './doctorIncentiveTesting.service';
import { UnsoldDescriptionService } from './unsoldDescription.service';
import { HaModelColorService } from './haModelColor.service';
import { PromoTypeService } from './promoType.service';
import { PromoReferenceService } from './promoReference.service';
import { CouponCodeService } from './couponCode.service';
import { CouponCodeClientService } from './couponCodeClient.service';
import { TransferCouponCodeService } from './transferCouponCode.service';
import { CampPromoUploadService } from './campPromoUpload.service';
import { UpdateLeadsService } from './updateLeads.service';
import { ReportMailConfigService } from './reportMailConfig.service';
import { EmployeeEmailConfigService } from './employeeEmailConfig.service';
import { TelecallerMasterService } from './telecallerMaster.service';
import { TelecallerSlotMasterService } from './telecallerSlotMaster.service';
import { AssignTelecallerService } from './assignTelecaller.service';
import { TelecallerTempAssignService } from './telecallerTempAssign.service';
import { WalkinApprovalService } from './walkinApproval.service';
import { FollowUpStatusMasterService } from './followUpStatusMaster.service';
import { PovConfigService } from './povConfig.service';
import { SalesTeamReportService } from './salesTeamReport.service';

export const APP_PROVIDERS: any[] = [
	AuthService,
	CommonService,
	ClientWalkInService,
	FollowUpService,
	SubscribeService,
	BranchService,
	EmployeeService,
	ClientService,
	ReferenceService,
	PocService,
	HearingLossService,
	BrandService,
	BrandmodelService,
	HamodelService,
	TestingBillService,
	ChallanOutService,
	ChallanInService,
	TransferChallanOutService,
	TransferChallanInService,
	SalesBillentryService,
	clientOutService,
	ReportsService,
	TestingTrailService,
	PurchasePartyService,
	ServiceWalkInService,
	FamilyService,
	UserService,
	ServiceEntryService,
	SalesReturnService,
	AdvanceReturnService,
	CashPaymentService,
	CashReceiptService,
	PhClientService,
	PurchaseInvoiceService,
	ServiceInvoiceService,
	PurchaseReturnService,
	NewPurchaseReturnService,
	EditService,
	FollowUpClientUploadService,
	CacService,
	ProTaskRemainderService,
	SmsService,
	BackupFollowUpClientService,
	DashboardService,
	// VoucherDateChangeService,
	AppointmentService,
	CashOutService,
	CashInService,
	ExpenseService,
	SeriesService,
	PowerService,
	PerformanceService,
	DesignService,
	BatteryService,
	HsnService,
	PartyNameService,
	CouponPointsService,
	DoctorService,
	LedgerMasterService,
	ExpenseTypeService,
	OctTypeService,
	DoctorIncentiveService,
	DoctorIncentiveTestingService,
	UnsoldDescriptionService,
	HaModelColorService,
	PromoTypeService,
	PromoReferenceService,
	CouponCodeService,
	TransferCouponCodeService,
	CouponCodeClientService,
	CampPromoUploadService,
	UpdateLeadsService,
	ReportMailConfigService,
	EmployeeEmailConfigService,
	TelecallerMasterService,
	TelecallerSlotMasterService,
	AssignTelecallerService,
	TelecallerTempAssignService,
	AiStatusService,
	AiCallConfigService,
	AiFollowupConfigService,
	AiTrackDayService,
	AiSettingsService,
	WalkinApprovalService,
	FollowUpStatusMasterService,
	PovConfigService,
	SalesTeamReportService
];

export * from './auth.service';
export * from './common.service';
export * from './clientWalkIn.service';
export * from './followUp.service';
export * from './subscribe.service';
export * from './branch.service';
export * from './employee.service';
export * from './client.service';
export * from './reference.service';
export * from './poc.service';
export * from './hearingLoss.service';
export * from './brand.service';
export * from './brandmodel.service';
export * from './hamodel.service';
export * from './testingBill.service';
export * from './challanOut.service';
export * from './challanIn.service';
export * from './tcOut.service';
export * from './tcIn.service';
export * from './salesBillentry.service';
export * from './clientOut.service';
export * from './reports.service';
export * from './testingTrail.service';
export * from './purchaseParty.service';
export * from './serviceWalkIn.service';
export * from './family.service';
export * from './user.service';
export * from './serviceEntry.service';
export * from './salesReturn.service';
export * from './advanceReturn.service';
export * from './cashPayment.service';
export * from './cashReceipt.service';
export * from './phClient.service';
export * from './purchaseInvoice.service';
export * from './serviceInvoice.service';
export * from './purchaseReturn.service';
export * from './newPurchaseReturn.service';
export * from './edit.service';
export * from './followUpClientUpload.service';
export * from './cac.service';
export * from './proTaskRemainder.service';
export * from './sms.service';
export * from './backupFollowUpClient.service';
export * from './dashboard.service';
// export * from './voucherdatechanges.service';
export * from './appointment.service';
export * from './cashOut.service';
export * from './cashIn.service';
export * from './expense.service';
export * from './series.service';
export * from './power.service';
export * from './performance.service';
export * from './design.service';
export * from './battery.service';
export * from './hsn.service';
export * from './partyName.service';
export * from './couponPoints.service';
export * from './doctor.service';
export * from './ledgerMaster.service';
export * from './expenseType.service';
export * from './octType.service';
export * from './doctorIncentive.service';
export * from './doctorIncentiveTesting.service';
export * from './unsoldDescription.service';
export * from './haModelColor.service';
export * from './promoType.service';
export * from './promoReference.service';
export * from './couponCode.service';
export * from './transferCouponCode.service';
export * from './couponCodeClient.service';
export * from './campPromoUpload.service';
export * from './updateLeads.service';
export * from './reportMailConfig.service';
export * from './employeeEmailConfig.service';
export * from './telecallerMaster.service';
export * from './telecallerSlotMaster.service';
export * from './assignTelecaller.service';
export * from './telecallerTempAssign.service';
export * from './aiStatus.service';
export * from './aiCallConfig.service';
export * from './aiFollowupConfig.service';
export * from './aiTrackDay.service';
export * from './aiSettings.service';
export * from './walkinApproval.service';
export * from './followUpStatusMaster.service';
export * from './povConfig.service';
export * from './salesTeamReport.service';



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/index.ts